import { gql } from "@apollo/client";

export const GET_ALL_EXCEPTION = gql`
    query ExceptionDictionaryQuery {
        getExceptionDictionaryForHeadquarters {
            exceptionReasonCode
            primaryType
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs 
            isUploadsImages
            isInternalException
            exceptionSubReasons {
                code
                textZh
                textEn
                textEs
            }
        }
    }
`;

export interface ExceptionSubReasonType {
    code: string;
    textZh: string;
    textEn: string;
    textEs: string;
}

export interface ExceptionDictionaryType {
    exceptionReasonCode: string;
    primaryType: string;
    secondaryTypeZh: string;
    secondaryTypeEn: string;
    secondaryTypeEs?: string;
    isUploadsImages: boolean;
    isInternalException?: boolean;  // 内部异常（如 QC 扣罚码）：仅系统写入，下拉不可人工选择
    exceptionSubReasons?: ExceptionSubReasonType[];  // 二级原因列表（包含国际化信息）
}

export interface ExceptionDictionaryResponse {
    getExceptionDictionaryForHeadquarters: ExceptionDictionaryType[];
}